import { render, staticRenderFns } from "./OnboardingQuestionDiabetesNotEligible.vue?vue&type=template&id=819c983e"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports